import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";

import UserSlice from "./users/reducer";
import RolSlice from "./roles/reducer"
import CustomerSlice from "./customers/reducer"



const rootReducer = combineReducers({
    Layout: LayoutReducer,
    Login: LoginReducer,
    ForgetPassword: ForgetPasswordReducer,
    Users: UserSlice,
    Roles: RolSlice,
    Customers: CustomerSlice,
});

export default rootReducer;
